import { apiClient } from './apiClient';

/**
 * Sets whether a contractor's submitted timesheets require approval (true) or are
 * approved automatically without a workflow (false).
 */
export async function updateEmployeeRequiresApproval(
  employeeId: number,
  requiresApproval: boolean
): Promise<{ success: boolean; message: string; requiresApproval: boolean }> {
  return apiClient.patch<{ success: boolean; message: string; requiresApproval: boolean }>(
    `/employees/${employeeId}/requires-approval`,
    { requiresApproval }
  );
}
